<template>
    <div class="container mt-5">
      <!-- Display Loading State -->
      <div v-if="loading" class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-3">Loading event data...</p>
      </div>
      
      <!-- Display Event Information Once Loaded -->
      <div v-else class="event-container bg-light p-4 rounded shadow-sm">
        <!-- Heading Section -->
        <div class="text-center mb-4">
          <h3 class="display-4 text-primary">Kedves {{ event.childName }}!</h3>
          <p class="lead">Leigazolod, hogy megérkeztél a <strong>{{ event.setDate }}</strong> táncórára?</p>
        </div>
        <!-- Buttons Section -->
        <div v-if="event.childResp === 0 || event.childResp === 10" class="d-flex justify-content-center">
          <button 
            class="btn btn-success btn-lg mx-3 px-4 py-2"
            @click="markAttendance(11)">
            <i class="fas fa-check-circle"></i> Igen
          </button>
        </div>
        <div v-else>
            {{ resp }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        loading: true,  // Loading state before data is fetched
        event: {},      // Event data to display
        hash: this.hash,
        resp : null,
        resp_enum : {
          0  : 0,
          11 : "Visszajeleztél, hogy megérkeztél az órára!",
          20 : "Visszajeleztél, hogy nem jössz!"
        }
      };
    },
    props: ['hash'],
    mounted() {
      // Fetch event data from the backend when the component is mounted
      this.fetchEventData();
    },
    methods: {
      async fetchEventData() {
        try {
          const response = await axios.get(`${this.$BACKEND_HOST}/api/checkhash/${this.hash}`);  // Replace with your backend API URL
          this.event = response.data;
          this.event.setDateBu = this.event.setDate;
          let date = new Date(this.event.setDate);
          this.event.setDate = date.toISOString().split('T')[0].replace(/-/g, '. ');
          this.loading = false; // Stop loading when data is fetched
          this.resp = this.resp_enum[this.event.childResp];
        } catch (error) {
          console.error('Error fetching event data:', error);
          this.loading = false;
        }
      },
      async markAttendance(status) {
        try {
          const payload = {
            status: status,
            child_id: this.event.childId,
            evnt_id  : this.event.grpId,
            set_date : this.event.setDateBu,
          };
          
          const response = await axios.post(this.$BACKEND_HOST + '/api/child/response', payload);  // Replace with your backend API URL

          if(response.data.message == "done")
          {
            this.resp = this.resp_enum[status];
            this.fetchEventData();
          }
        } catch (error) {
          console.error('Error marking attendance:', error);
          alert('Failed to mark attendance. Please try again.');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Optional: Customize styling if necessary */
  .container {
    max-width: 600px;
  }
  
  .event-container {
    background-color: #f8f9fa; /* Light grey background */
    border: 1px solid #ddd;    /* Subtle border */
    border-radius: 8px;        /* Rounded corners */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Box shadow for a subtle 3D effect */
  }
  
  h3 {
    font-weight: 600;
  }
  
  button i {
    margin-right: 8px;
  }
  
  /* Button styles moved to components.css */
  </style>
  